var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.001,
    height: 17.144,
    viewBox: "0 0 15.001 17.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M-4.642-15.357H-5.981V-16.7a.8.8,0,0,0-.774-.8.851.851,0,0,0-.834.8v1.339H-12.41V-16.7a.8.8,0,0,0-.8-.8.8.8,0,0,0-.8.8v1.339h-1.339A2.143,2.143,0,0,0-17.5-13.214V-2.5A2.143,2.143,0,0,0-15.357-.356H-4.642A2.143,2.143,0,0,0-2.5-2.5V-13.214A2.144,2.144,0,0,0-4.642-15.357Zm.536,4.286v3.482H-9.2v-3.482Zm-6.7,0v3.482h-5.09v-3.482ZM-15.893-2.5V-5.981h5.09v4.018h-4.554a.537.537,0,0,1-.536-.536Zm11.251.536H-9.2V-5.981h5.09V-2.5A.537.537,0,0,1-4.642-1.963Z",
    transform: "translate(17.5 17.5)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.383298b968616b8599a35829005c54bf.svg";
export { ForwardRef as ReactComponent };